import(/* webpackMode: "eager" */ "/app/src/app/services/integrations/page.tsx");
